import { defineStore } from 'pinia'
import type {} from 'pinia-plugin-persistedstate'
import {
    getLocationFromNavigator,
    EXTENDED_GEOLOCATION_POSITION_ERROR_MAP,
    type GeoStatus,
} from '@/modules/geo'

interface GeoState {
  lat: number | null
  long: number | null
  accuracy: number | null
  time: string | null
  error: string | null
  status: GeoStatus
}

export const useGeoStore = defineStore('geo', {
  persist: true,
  state: (): GeoState => ({
    lat: null,
    long: null,
    accuracy: null,
    time: null,
    error: null,
    status: 'NONE',
  }),

  getters: {
    acquired: (state): boolean => state.status !== 'NONE',
  },

  actions: {
    async getPosition(): Promise<boolean> {
      try {
        const position = await getLocationFromNavigator()
        const time = new Date(position.timestamp).toISOString()

        this.$patch({
          lat: position.coords.latitude,
          long: position.coords.longitude,
          accuracy: position.coords.accuracy,
          time,
          error: null,
          status: 'CURRENT',
        })
        return true
      } catch (e) {
        const err = e as GeolocationPositionError
        const errorValue = EXTENDED_GEOLOCATION_POSITION_ERROR_MAP[err.code]
        const status: GeoStatus = this.acquired ? 'LAST_KNOWN' : 'NONE'

        this.$patch({
          error: errorValue,
          status,
        })
        return false
      }
    },
  },
})
